import * as Yup from "yup";

export const expenseCategorySchema = Yup.object({
  expense_category: Yup.object({
    name: Yup.string()
      .trim()
      .required("Name is Required"),

    housing_auth: Yup.boolean(),
    housing_deposit: Yup.boolean(),
    unit_required: Yup.boolean(),

    housing_auth_state_id: Yup.object()
      .shape({
        value: Yup.string().required("Housing Auth State is required"),
        label: Yup.string(),
      })
      .nullable()
      .when("housing_auth", {
        is: true,
        then: (schema) => schema.required("Housing Auth State is required"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    housing_auth_county_ids: Yup.mixed().when("housing_auth", {
      is: (value) => value === true,
      then: (schema) => schema.required("Housing Auth County is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    housing_deposit_state_id: Yup.object()
      .shape({
        value: Yup.string().required("Housing Deposit State is required"),
        label: Yup.string(),
      })
      .nullable()
      .when("housing_deposit", {
        is: true,
        then: (schema) => schema.required("Housing Deposit State is required"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    housing_deposit_county_ids: Yup.mixed().when("housing_deposit", {
      is: (value) => value === true,
      then: (schema) => schema.required("Housing Deposit County is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    unit_required_state_id: Yup.object()
      .shape({
        value: Yup.string().required("Unit State is required"),
        label: Yup.string(),
      })
      .nullable()
      .when("unit_required", {
        is: true,
        then: (schema) => schema.required("Unit State is required"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    unit_required_county_ids: Yup.mixed().when("unit_required", {
      is: (value) => value === true,
      then: (schema) => schema.required("Unit County is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    calculation: Yup.string().required("Calculation is Required"),
  }),
});

export const expenseCategoryInitialValues = {
  expense_category: {
    status: true,
    name: "",
    housing_auth: false,
    housing_deposit: false,
    unit_required: false,
    housing_auth_state_id: null,
    housing_auth_county_ids: "",
    housing_deposit_state_id: null,
    housing_deposit_county_ids: "",
    unit_required_state_id: null,
    unit_required_county_ids: "",
    calculation: "",
  },
};
